export default {
    getCurrentVideo (state) {
        return state.currentVideoObject
    },
    getPromoVideo (state) {
        return state.currentPromoVideoObject
    },
    getCurrentStatus (state) {
        return state.currentVideoStatus
    },
    getCurrentVideoTranscript (state) {
        return state.currentVideoTranscript
    },
    getCurrentVideoDurationWatched (state) {
        return state.currentVideoDurationWatched
    },
    getVideEndMessage (state) {
        return state.videoEndMessage
    },
    getVideEndGif (state) {
        return state.videoEndGif
    },
    getCopiedPlaylistObject (state) {
        return state.copiedPlaylistObject
    },
    getOriginalVideoCode (state) {
        return state.originalVideoCode
    },
    getOriginalVideoTitle (state) {
        return state.originalVideoTitle
    },
    getVideoSubcategories (state) {
        return state.videoSubCategories
    },
    getCorporatePayload (state) {
        return state.corporatePayload
    },
    getB2BVideos (state) {
        return state.B2BVideos
    },
    getB2BTopVideo (state) {
        return state.b2BTopVideo
    },
    getTaggedEmailList (state) {
        return state.taggedEmailList
    },
    getArchivePlaylistObject (state) {
        return state.archivePlaylistObject
    },
    getItemChangeInPlaylist (state) {
        return state.itemChangeInPlaylist
    },
    getServicePodcast (state) {
        return state.servicePodcast
    },
    getUserNewPlaylistObject (state) {
        return state.userNewPlaylistObject
    },
    getTrendingNewPlaylistObject (state) {
        return state.trendingNewPlaylistObject
    },
    getCorpNewPlaylistObject (state) {
        return state.corpNewPlaylistObject
    }
}



// WEBPACK FOOTER //
// ./src/store/videoplayer/getters.js